export const IsLoggedIn = () =>  {
    const cusToken = localStorage.getItem("cusToken") !== null ? localStorage.getItem("cusToken").replace(/"/g, '') : "";
    return !!cusToken;
}